<div class="agreement-padding">
    <div class="container">
        <div class="mw-900 mx-auto">
            <div class="privacyPolicyDiv" id="privacyPolicyDiv"></div>
        </div>
    </div>
</div>